export default __webpack_public_path__ + "static/media/exchange (1).04190afb.png";